import { useState, useEffect } from 'react'

/**
 * useLocalStorage hook for managing localStorage state in React.
 * @param {string} key - The localStorage key.
 * @param {any} initialValue - The initial value to use if localStorage is empty.
 * @returns {[any, Function, Function]} - [value, setValue, removeValue]
 */
function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') return initialValue
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    if (typeof window === 'undefined') return
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue))
    } catch {}
  }, [key, storedValue])

  const setValue = value => {
    setStoredValue(value)
  }

  const removeValue = () => {
    setStoredValue(initialValue)
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(key, JSON.stringify(initialValue))
    }
  }

  return [storedValue, setValue, removeValue]
}

export default useLocalStorage
